import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GetListOfVendorsByEmployeeID, ShareLinkToVendor, siteURL } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ShareInterviewDetailsToVendor = () => {
    const { register, handleSubmit, formState: { errors, isSubmitting }, setValue, reset } = useForm();
    let query = useQuery();
    const guid = query.get("guid");
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [detailsType, setDetailsType] = useState("");  // State for storing detailsType
    const [selectedEmail, setSelectedEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { selectedCountry} = useCountry();
    let Guid="";
const token = localStorage.getItem("jwtToken");
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const roleID = localStorage.getItem("roleID")

    if (roleID == 3) {
        Guid = employerGuid
    } else {
        Guid = userguid
    }

    const getInterviewDetails = async () => {
        setIsLoading(true);
        const GetapiUrl = `${GetListOfVendorsByEmployeeID.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        const result = await Axios.get(GetapiUrl);
        const interviewData = result.data.filter((x) => x.vendorCompanyName && x.vendorEmail && x.vendorName);
        setVendors(interviewData);
        setIsLoading(false);
    };

    let link = "";
    if (detailsType === "1") {
        link = `${siteURL}/HomeViewFullInterviewCompletedCandidateDetails?guid=${guid}&detailsType=1&CountryID=${selectedCountry}`;
    } else if (detailsType === "2") {
        link = `${siteURL}/HomeViewPartialInterviewCompletedCandidateDetails?guid=${guid}&detailsType=2&CountryID=${selectedCountry}`;
    }
    else if (detailsType === "3") {
        link = `${siteURL}/HomeViewMaskInterviewCompletedCandidateDetails?guid=${guid}&detailsType=3&CountryID=${selectedCountry}`;
    }

    const onSubmit = async (data, e) => {
        e.preventDefault();
        reset();

        setIsLoading(true);

        const apiUrl = ShareLinkToVendor.APIURL;
        try {
            const params = {
                "vendorEmail": data.vendorEmail,
                "link": link,
                "logolink":"string",
                "employerGuid": Guid
            };
            const result = await Axios.post(apiUrl, params, { headers: { Authorization: `Bearer ${token}` } });

            setIsLoading(false);
            if (result.data === 'Updated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Shared Successfully',
                    showConfirmButton: false,
                    timer: 5000
                });
                navigate("/Employer/GetInterviewCompletedCandidates");
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Add correct Details',
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        } catch (error) {
            console.log("Error" + error);
            setIsLoading(false);
        }
    };

    const handleClick = () => {
        if (detailsType) {
            const finalURL = link;
            navigator.clipboard.writeText(finalURL)
                .then(() => console.log('URL copied to clipboard'))
                .catch(err => console.error('Failed to copy URL: ', err));
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Copied',
                    showConfirmButton: false,
                    timer: 1000,
                  }); 
        } else {
            alert("Please Select details type")
        }
    };

    const handleVendorChange = (event) => {
        const selectedVendor = vendors.find(vendor => vendor.vGuid == event.target.value);
        if (selectedVendor) {
            setSelectedEmail(selectedVendor.vendorEmail);
            setValue("vendorEmail", selectedVendor.vendorEmail);
        } else {
            setSelectedEmail("");
            setValue("vendorEmail", "");
        }
    };

    const handleDetailsTypeChange = (event) => {
        setDetailsType(event.target.value);
    };

    useEffect(() => {
        getInterviewDetails();
    }, []);

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                <Link to="/Employer/GetInterviewCompletedCandidates">
                                    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
                                </Link>
                                <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Share Review</h2>
                            </div>
                            <button onClick={handleClick} disabled={isSubmitting || isDisabled} className="btn btn-primary">
                                Copy
                            </button>
                        </div>
                        <hr />
                        <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                            <div className="row mt-2">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row p-3">
                                        <div className="col-sm-12 col-lg-2 col-xl-2 col-md-2"></div>
                                        <div className="col-sm-12 col-xl-5 col-lg-5 col-md-5">
                                            <select
                                                {...register("vendorCompanyName", { required: "Company Name Required" })}
                                                className={`form-control basic-form mt-3 ${errors.vendorCompanyName ? 'is-invalid' : ''}`}
                                                style={{ height: 50, borderRadius: 15 }}
                                                onChange={handleVendorChange}
                                            >
                                                <option value="">Select Company Name</option>
                                                {vendors.map((vendor, index) => (
                                                    <option key={index} value={vendor.vGuid}> {vendor.vendorName} - {vendor.vendorCompanyName}</option>
                                                ))}
                                            </select>
                                            <div className="invalid-feedback"> {errors.vendorCompanyName?.message}</div>

                                            <input
                                                type="text"
                                                {...register("vendorEmail", { required: "Email Required" })}
                                                className={`form-control basic-form mt-3 ${errors.vendorEmail ? 'is-invalid' : ''}`}
                                                placeholder="Vendor Email"
                                                value={selectedEmail}
                                                readOnly
                                            />
                                            <div className="invalid-feedback"> {errors.vendorEmail?.message}</div>

                                            <select
                                                {...register("detailsType", { required: " Details Type Required" })}
                                                className={`form-control basic-form mt-3 ${errors.detailsType ? 'is-invalid' : ''}`}
                                                style={{ height: 50, borderRadius: 15 }}
                                                onChange={handleDetailsTypeChange} // Update detailsType state
                                            >
                                                <option value="">Select Details Type</option>
                                                <option value="1">Full Details</option>
                                                <option value="2">Partial Details</option>
                                                {/* <option value="3">Masking Details</option> */}
                                            </select>
                                            <div className="invalid-feedback"> {errors.detailsType?.message}</div>
                                        </div>
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => navigate("/Employer/GetInterviewCompletedCandidates")}
                                        style={{ float: "right", marginRight: 10 }}
                                        disabled={isSubmitting || isDisabled}
                                        className="btn btn-primary"
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        id="svbutton"
                                        style={{ float: "right" }}
                                        disabled={isSubmitting || isDisabled}
                                        className="btn btn-primary pf-save mb-3 mr-3"
                                    >
                                        {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        Share
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </section>
        </ConsultantLayout>
    );
};

export default ShareInterviewDetailsToVendor;
